import React,{useState} from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png"
import icon1 from "../../assets/images/icon1.png"
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import icrageeLogo from "../../assets/images/icragee.png"
import Footer from "../../components/Footer/Footer";
import venueImage from "../../assets/images/venue.png"
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg"
import mapImage from "../../assets/images/map.png"
import Navbar from "../../components/Navbar/Navbar"
import Layout from "../../components/Layout/layout";
const AboutIITG = () => {
    
    return(
        <Layout>
        <main className="bg-gray-100">
           
      <div className="flex justify-center">
      <div className="flex absolute md:mt-[-10vw] mt-[-35vw] md:flex-row flex-col items-center w-full justify-center gap-12">
        <div className="text-[55px] text-white" 
            style={{fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000'}}
            >
                ABOUT IIT GUWAHATI
            </div>
        </div>
      <div className="w-full md:w-3/4 md:px-20 px-10 py-32 border-2 my-10 bg-white  text-justify">
            <div className="font-bold text-2xl md:text-5xl text-sky-800 mb-10">
                IIT Guwahati
            </div>
            <div className="text-xl md:text-3xl mb-4">
            Indian Institute of Technology Guwahati, the sixth member of the IIT fraternity, was established in 1994. The campus is on a sprawling 704 acres, consisting of lakes, hills and is located on the north bank of the mighty River Brahmaputra around 20 km from the heart of the Guwahati city. Flanked by the majestic Brahmaputra, hills and vast open space, the campus provides an ideal setting for knowledge dissemination. The serene campus with a richness of greenery, scenic beauty, flora and fauna makes it a treasure trove of academics and learning. IIT Guwahati has 11 academic departments, 7 interdisciplinary academic centers and five schools. IIT Guwahati has been ranked 32 globally in “Research citation per faculty and overall QS ranking of 384 in the year 2023. The campus is located close to 27 km from LGB international airport Guwahati and approximately 24 km from Guwahati Railway Station.
            </div>
            <div className="text-xl md:text-3xl text-blue-500 text-underline"><a href="https://www.iitg.ac.in/">Click here to visit the website</a></div>
        </div>
        
      </div>
      
        </main>
        </Layout>
    );
}
export default AboutIITG;